export default __webpack_public_path__ + "static/media/img12.febba17d.webp";